/**
 * The `data-tone` of a CRM team (group) chip: call center purple, sales green, control amber,
 * everything else grey. The tone feeds the chip through the shared [data-tone] tokens, so the
 * colours follow the theme.
 */
const TEAM_TONE = {
  CALL_CENTER: 'purple', SALES: 'success', CONTROL: 'brand', GENERAL: 'neutral',
};

export function groupTone(type) {
  return TEAM_TONE[type] || 'neutral';
}
